import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const ProtectedRoute = ({ children }) => {
  const isAuth = secureLocalStorage.getItem("isAuth") !== null;
  const role = secureLocalStorage.getItem("role");

  const getLoginRoute = (role) => {
    if (
      role === "super user" ||
      role === "support" ||
      role === "relationship manager"
    ) {
      return "/admin/login";
    } else if (role === "hospital" || role === "company" || role === "agency") {
      return "/parter/login";
    } else {
      return "/";
    }
  };

  if (!isAuth) {
    const redirectTo = getLoginRoute(role);
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
